import { FollowersDisplayState } from './display.types';

export const getDefaultDisplay = (): FollowersDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: FollowersDisplayState = getDefaultDisplay();
